import React from 'react';

function Logo(props) {
  return (
    <img
      alt="Logo"
      src="/static/Tenet_logo_White-01-small.png"
      {...props}
    />
  );
}

export default Logo;
